module.exports = __webpack_public_path__ + "img/advantage_txt.b6f1ce4e.png";